import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { exportPIMData, pimCreateCustomerTemplate } from "@tecumseh/Services/PIMExportService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface  PIMExportApiResult {
    isSuccess: boolean;
    message: string;
}
type HandlerType = CustomApiHandler<any>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/PIMExport/StartExporting",
    });
};

export const PIMExportCompleted: HandlerType = async props => {
    if(props.parameter){
        try {
            let result:any;
            if( props?.parameter?.isUploadTemplate){
                result = await pimCreateCustomerTemplate(props.parameter.aPiparameter);
            } else {
                result = await exportPIMData(props.parameter.aPiparameter);
            }
            
            const response: any = JSON.parse(result);
            props.parameter?.onSuccess(response);
            if(response.isSuccess){
                props.dispatch({
                    type: "Custom/PIMExport/ExportCompleted",
                    exportResponse: response,
                });
            } else {
                props.dispatch({
                    type: "Custom/PIMExport/ExportFail",
                    exportResponse: response,
                });
            }
            
        } catch (error) {
            throw error;
        }
    }
        
};



export const chain = [StartLoading, PIMExportCompleted];

const pimDataExport = createHandlerChainRunner(chain, "pimDataExport");
export default pimDataExport;
